import React from "react";

// const stats = [
//   { label: "Projects Done", value: 1984 },
//   { label: "Happy Clients", value: 100, suffix: "%" },
//   { label: "Awards Won", value: 25 },
// ];

// function Counter({ end, suffix = "" }) {
//   const [count, setCount] = useState(0);
//   const ref = useRef(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           let start = 0;
//           const duration = 1200;
//           const step = 20;
//           const increment = end / (duration / step);

//           const timer = setInterval(() => {
//             start += increment;
//             if (start >= end) {
//               setCount(end);
//               clearInterval(timer);
//             } else {
//               setCount(Math.floor(start));
//             }
//           }, step);

//           observer.disconnect();
//         }
//       },
//       { threshold: 0.4 }
//     );

//     if (ref.current) observer.observe(ref.current);
//     return () => observer.disconnect();
//   }, [end]);

//   return (
//     <span
//       ref={ref}
//       className="text-4xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent"
//     >
//       {count.toLocaleString()}
//       {suffix}
//     </span>
//   );
// }

export default function StatsAndCTA() {
  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">

        {/* STATS */}
        {/* <div className="grid md:grid-cols-3 gap-12 text-center mb-20">
          {stats.map((s, i) => (
            <div key={i} className="relative">
              <Counter end={s.value} suffix={s.suffix} />
              <p className="mt-2 text-gray-600 font-medium">
                {s.label}
              </p>

              {i !== stats.length - 1 && (
                <span className="hidden md:block absolute top-1/2 right-0 h-12 w-px bg-gray-200 -translate-y-1/2"></span>
              )}
            </div>
          ))}
        </div> */}

        {/* CTA BAR */}
        <div
          className="relative rounded-3xl p-12 md:p-16
          bg-gradient-to-r from-indigo-600 to-purple-600
          shadow-[0_25px_60px_-15px_rgba(99,102,241,0.5)]
          flex flex-col md:flex-row items-center justify-between gap-10
          hover:scale-[1.02] transition-transform duration-500"
        >
          {/* Text */}
          <h3 className="text-white text-2xl md:text-3xl font-semibold max-w-2xl leading-snug">
            We are here to help your business.
            <br />
            Let’s discuss your solution today.
          </h3>

          {/* Call */}
          <div className="flex items-center gap-4 text-white">
            <div
              className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white/20 backdrop-blur
  flex items-center justify-center text-xl sm:text-2xl animate-pulse"
            >
              📞
            </div>

            <span className="text-xl sm:text-2xl font-bold tracking-wide whitespace-nowrap">
              +91 8586 036 036
            </span>
          </div>
        </div>

      </div>
    </section>
  );
}
